import axios from 'axios';
import config from './config';

const instance = axios.create({
  baseURL: config.api.baseURL
});

// Add a request interceptor
instance.interceptors.request.use(function (axiosConfig) {
  const token = localStorage.getItem(config.api.token);
  axiosConfig.headers = {
    'Content-Type': 'application/json',
    UserToken: token
  };
  // Do something before request is sent
  return axiosConfig;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});


// Add a response interceptor
instance.interceptors.response.use(function (response) {
  //console.log(response);
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  return Promise.reject(error);
});
export default instance;



// WEBPACK FOOTER //
// ./src/lib/axios.js